import { render } from "./ConfirmMailPage.vue?vue&type=template&id=98b07b9a&ts=true"
import script from "./ConfirmMailPage.vue?vue&type=script&lang=ts"
export * from "./ConfirmMailPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Authentication/ConfirmMailPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "98b07b9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('98b07b9a', __exports__)) {
    api.reload('98b07b9a', __exports__)
  }
  
  module.hot.accept("./ConfirmMailPage.vue?vue&type=template&id=98b07b9a&ts=true", () => {
    api.rerender('98b07b9a', render)
  })

}


export default __exports__